import React, {useEffect, useRef, useState} from "react";
import isEqual from "lodash/isEqual";
import sortBy from "lodash/sortBy";
import {useGetDataVendorQuery} from "../api/dataVendorApiSlice";
import {useGetCurrentUserQuery} from "../api/userApiSlice";

export function genRanHex(size= 5) {
  return [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
}

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export function IsJsonValid(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function snakeToCamel(s) {
  return s.replace(/(\_\w)/g, function(m){return m[1].toUpperCase();});
}

export function usePropState(propValue) {
  const [value, setValue] = useState(propValue);

  useEffect(() => {
    setValue(propValue)
  }, [propValue]);

  return [value, setValue];
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

export function useOutsideAlerter(onOutsideClick) {
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick()
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {// Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onOutsideClick]);
  return ref
}

export function useDifactoBucket() {
  const { data: {bucket} = {}, success } = useGetCurrentUserQuery()
  return bucket
}

export function useHistoryState(props, propName) {
  if (props.history.location.state) {
    return props.history.location.state[propName]
  } else {
    return null
  }
}

export function isArrayEqual(x, y) {
  return isEqual(sortBy(x), sortBy(y))
}

export function useEffectArray(callback, [dependency]) {
  const optionsRef = useRef(dependency)
  if (!isEqual(optionsRef.current, dependency)) {
    optionsRef.current = dependency
  }
  useEffect(() => {
    callback()
  }, [optionsRef.current])
}

export function useAdminBucket(dataVendorKey) {
  const [bucket, setBucket] = useState('')
  const { data: dataVendor } = useGetDataVendorQuery(dataVendorKey)

  useEffect(() => {
    setBucket(dataVendor?.bucket)
  }, [dataVendor])

  return bucket
}

export function childrenWithProps(children, props) {
  return React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, props);
    }
    return child;
  });
}

export function useDebug(prop, stop = true) {
  useEffect(() => {
    if (stop) {
      debugger
    }
  }, [prop])
}

export function useFormattedLanguage(t) {
  return (language) => {
    return language ? t(`languages.${language}`) : null
  }
}
